module.exports = __webpack_public_path__ + "assets/fonts/helvetica-neue/WOFF/HelvNeue55_W1G.woff";